import * as Sentry from '@sentry/react';

export function captureAsyncError(error: unknown): void {
  Sentry.captureException(error);
}
